<template>
  <div class='pointer-events-auto h-full w-screen max-w-xs text-white'>
    <div class='flex h-full flex-col overflow-y-scroll border-l border-l-gray-600 bg-gray-700 px-3 shadow-xl'>

      <div v-if='filters.public_filters.length'>
        <div class='mt-4 flex flex-row items-center justify-between px-3 pb-3'>
          <span class='pl-2 text-sm font-bold uppercase'>Public Filters</span>
        </div>

        <div class='flex flex-col gap-2 pb-4'>
          <div
            v-for='filter in filters.public_filters'
            :key='filter?.id'
            :class='[filter?.id === activeFilter?.id ? "bg-gray-800" : "bg-gray-700"]'
            class='flex cursor-pointer flex-row items-center justify-between rounded-lg py-1.5 px-4 hover:bg-gray-600'
            @click='selectFilter(filter)'
          >
            <span class='text-xs'>{{ filter.name }}</span>
          </div>
        </div>
      </div>

      <div v-if='filters.private_filters.length'>
        <DividerComponent
          v-if='filters.public_filters.length'
          divider-color='border-gray-400'
        />

        <div class='flex flex-row items-center justify-between p-3'>
          <span class='pl-2 text-sm font-bold uppercase'>Private Filters</span>
        </div>

        <div class='flex flex-col gap-2 pb-4'>
          <div
            v-for='filter in filters.private_filters'
            :key='filter?.id'
            :class='[filter?.id === activeFilter?.id ? "bg-gray-800" : "bg-gray-700"]'
            class='flex cursor-pointer flex-row items-center justify-between rounded-lg py-1.5 px-4 hover:bg-gray-600'
            @click='selectFilter(filter)'
          >
            <span class='text-xs'>{{ filter.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
  import { defineComponent, ref, watch } from 'vue'
  import DividerComponent from '@/components/partials/DividerComponent.vue'
  import { useFilterStore } from '@/store/filter'
  import router from '@/router'
  import { ExtendedFilter } from '@/types/api/filter/filterTypes'

  export default defineComponent({
    name: 'FilterMenuContent',
    components: {
      DividerComponent,
    },
    props: {
      currentModule: {
        type: Object,
        required: true,
      },
    },
    setup(props) {
      const filterStore = useFilterStore()
      const activeFilter = ref()

      const filters = ref({
        public_filters: [],
        private_filters: [],
        active_filter: {
        },
      })

      watch(() => props.currentModule, () => {
        filters.value.public_filters = props.currentModule.public_filters
        filters.value.private_filters = props.currentModule.private_filters
      })

      watch(() => filterStore.activeFilter, (filter) => {
        activeFilter.value = filter
      })

      const selectFilter = (filter: ExtendedFilter) => {
        filterStore.setActiveFilter(filter)
        router.push('/' + props.currentModule.name)
      }

      return {
        activeFilter,
        filterStore,
        filters,
        selectFilter,
      }
    },
  })
</script>
